import { match } from "node:assert";

export const controlState = {
    ShareModelOpen: false,
    generalModelinfo: {
      type:'warning_gender',  // warning_gender , warning_level 
      info:{
        gender:'',
        match_gender:"",
        level:0,
        match_level:0,
      },
      key:'',
      itemIndex:0,
      rowData:{},
      isOpen:false
    },
    shareModelInfo: {
        link:null,
    },
    homeSidebarInfo:{
        type:'booking',
        matchType:'public',
        bookingId:0,
        actionType:'new',
        isOpen:false,
    },
    customDatePortalInputOpen:false,
    pathQueue: [window.location.href], // Start with current URL
  currentIndex: 0,
  viewMode:false,
  calenderBookingType:'booking',
  isOpenSidebar:true,
  DragElemntInfo:{},
  newReadedMsgs:[],
  systemModelOpen:false,
  SystemModelType:'',
  windowPathname:"",
  filter:{},
  SystemModelInfo:{},
  sortingBy:{
    column:'',
    order:''
  }
}